import _ from 'lodash';
import {
    USER_LOADING,
    USER_ROLES_UPDATE,
    USER_UPDATE,
    USERS_ERROR,
    USERS_LOADING,
    USERS_UPDATE,
} from '../actions/userActions';

const INITIAL_STATE = {
    users: [],
    usersPagination: null,
    usersLoading: false,
    userLoading: false,
    usersError: null,
    userRoles: [],
};

export default (state = INITIAL_STATE, action) => {
    switch ( action.type ) {
        case USERS_UPDATE:
            return {
                ...state,
                users: _.mapKeys(action.payload.data, 'id'),
                usersPagination: action.payload.pagination,
                usersError: action.payload.message,
            };
        case USER_UPDATE:
            const user = action.payload.data;
            const users = { ...state.users, [user.id]: user };
            return { ...state, users: users };
        case USERS_ERROR:
            return {
                ...state,
                usersError: action.payload,
            };
        case USERS_LOADING:
            return { ...state, usersLoading: action.payload };
        case USER_LOADING:
            return { ...state, userLoading: action.payload };
        case USER_ROLES_UPDATE:
            return { ...state, userRoles: [...INITIAL_STATE.userRoles, ...action.payload.data] };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/app/users/reducers/UserReducer.js